var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6.848c.316-.317.316-.844 0-1.196L3.094.872c-.352-.317-.88-.317-1.196 0l-.808.808c-.317.351-.317.879 0 1.195l3.41 3.41L1.09 9.66c-.317.317-.317.844 0 1.195l.808.774c.317.351.844.351 1.196 0l4.781-4.781Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.da48eb57cc1b3eaacefd183ba1a7c8da.svg";
export { ForwardRef as ReactComponent };